<div class="search-funds-wrapper">
    <div class="d-flex align-items-end justify-content-between search-funds-input" [ngClass]="{'filter-pannel__open':showFilters }">
      <div class="search-input-wrapper" role="search" #searchContainer>
        <c11n-search
          (stateChange)="searchFunds()($event)"
          [id]="'fund-search'"
          [size]="'medium'"
          [labelText]="fd3ContentGenericListResponse['searchPlaceholder']"
          [hideLabel]="false"
          [hideSearchButton]="false"
          [hasMenu]="false"
          [menuItemCount]="0"
          [placeHolderText]=""
          [clearLabelText]="'Clear search input'"
          [submitLabelText]="'Search'">
        </c11n-search>
      </div>
      <c11n-button
        variant="ghost"
        [labelText]="showFilters ? fd3ContentGenericListResponse['hideFilters'] : fd3ContentGenericListResponse['showFilters']"
        [ariaLabelText]="showFilters  ? fd3ContentGenericListResponse['hideFilters'] + filtersExpanded: fd3ContentGenericListResponse['showFilters']+ filtersCollapsed "
        (clickEvent)="openFilters()"
        class="search-filter c11n-space-inline-left-5x d-flex align-items-center"
      ></c11n-button>
    </div>
    <div [attr.inert]="!showFilters ? true : null"  class="search-filters-view-wrapper" [@hightGrow]="{ value: currentState, params: { height: '0', expandedHeight: divHeight } }">
        <div class="search-filters-panel" #filtersPanel>
          <div class="filter-title-wrapper d-flex align-items-center justify-content-between">
            <h2 class="c11n-text-lg-headline default-padding">{{fd3ContentGenericListResponse['filters']}}</h2>
            <div class="close-icon d-flex align-items-center">
              <a role="button" class="c11n-link c11n-text-md-bold" href="javascript:void(0);" (click)="clearAllFilter();">
                <span class="c11n-link__content">{{fd3ContentGenericListResponse['clearAll']}}</span>
              </a>
            </div>
          </div>
          <div class="search-filters-list-wrapper flex-start">
            <div class="search-filters-list-items">
              <h4 class="c11n-text-md-bold c11n-space-stack-2x">{{fd3ContentFiltersListResponse['product']}}</h4>
              <product-type-filter></product-type-filter>
            </div>
            <div class="search-filters-list-items">
              <h4 class="c11n-text-md-bold c11n-space-stack-2x">{{fd3ContentFiltersListResponse['filterBy']}}</h4>
              <fieldset>
                <legend class="visually-hidden">Filter By Select one option from either Asset class or strategy </legend>
                <asset-class-strategy-filter [filterByLabHeader]="filterByLabel"></asset-class-strategy-filter>
              </fieldset>
            </div>
            <div class="search-filters-list-items">
              <div class="search-filters-list-items-wrapper">
                <sub-asset-filter></sub-asset-filter>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
  <div class="applied-filter-wrapper">
    <applied-filter [isShowFilters]="showFilters"></applied-filter>
  </div>
